import apiClient from "./axios";

export const getColors = async (params = {}) => {
  const { data } = await apiClient.get("/colors", { params });
  return data;
};

export const getColor = async (id) => {
  const { data } = await apiClient.get(`/colors/${id}`);
  return data;
};

export const createColor = async (colorData) => {
  const { data } = await apiClient.post("/colors", colorData);
  return data;
};

export const editColor = async ({ id, ...colorData }) => {
  const { data } = await apiClient.patch(`/colors/${id}`, colorData);
  return data;
};

export const deleteColor = async (id) => {
  const { data } = await apiClient.delete(`/colors/${id}`);
  return data;
};
